import { HttpClient, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Service } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from './loading.service';
import { NotifierService } from './notifier.service';
import { Observable, tap } from 'rxjs';

export class ajaxCallReturnValue<T> {
    success: boolean;
    results: T;
    message: string;
}

export class DataTablesResponse<T> {
    constructor() {
        this.recordsTotal = 0;
        this.recordsFiltered = 0;
        this.data = [];
    }
    recordsTotal: number;
    recordsFiltered: number;
    data: T[];
}


@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
    public static readonly storageKey: string = 'X-Neo-Info';

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.method == 'POST') {
            var sendData = localStorage.getItem(LoggingInterceptor.storageKey);
            const reqWithHeader = sendData ? request.clone({ headers: request.headers.set(LoggingInterceptor.storageKey, sendData) }) : request.clone();

            return next.handle(reqWithHeader).pipe(
                tap({
                    next: (event: HttpEvent<any>) => {
                        if (event.type == HttpEventType.Response) {
                            var keyData = event.headers.get(LoggingInterceptor.storageKey);
                            if (keyData) {
                                localStorage.setItem(LoggingInterceptor.storageKey, keyData);
                            } else {
                                LoggingInterceptor.clear();
                            }
                        }
                    },
                    error: (error) => {
                    }
                })
            );
        }
        return next.handle(request);
    }

    static clear(): void {
        localStorage.removeItem(LoggingInterceptor.storageKey);
    }

    static keyData(): string | null {
        return localStorage.getItem(LoggingInterceptor.storageKey);
    }
}

@Service()
export class AjaxCallService {
    private http = inject(HttpClient);
    private router = inject(Router);
    private notifier = inject(NotifierService);
    private loading = inject(LoadingService);

    public MakeCall<T>(url: string, object?: any, doLoading?: boolean): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            doLoading = ((typeof doLoading !== 'undefined') ? doLoading : true);

            if (doLoading) {
                this.loading.inc(url);
            }

            url = '/data' + url;

            this.http.post<ajaxCallReturnValue<T>>(url, object).subscribe({
                next: (response) => {
                    if (response.success) {
                        resolve(response.results);
                        return;
                    }
                    if (response.message) {
                        if (doLoading) {
                            this.notifier.error(response.message);
                        }
                        console.error(url, response.message);
                    }
                    reject(response);

                }, error: (response) => {
                    if (doLoading) {
                        this.loading.dec(url);
                    }

                    if (response.status === 403 || response.status === 401) {
                        this.router.navigateByUrl('/login');
                        return;
                    }

                    reject();
                }, complete: () => {
                    if (doLoading) {
                        this.loading.dec(url);
                    }
                }
            });
        });
    }

    ClearLogin(): void {
        LoggingInterceptor.clear();
    }

}
